import React from 'react';
const duration = (seconds = 0) => {
  const n = Math.max(0, Math.floor(Number(seconds) || 0));
  return n >= 3600 ? `${Math.floor(n/3600)}h ${Math.floor(n%3600/60)}m ${n%60}s`
    : n >= 60 ? `${Math.floor(n/60)}m ${n%60}s` : `${n}s`;
};
export default function SupportCallTimeline({ call }) {
  const when = call.startedAt || call.createdAt;
  return <div style={{display:'flex',justifyContent:'center',padding:'7px 10px',width:'100%',flexShrink:0}}>
    <div style={{width:'min(100%,310px)',padding:'11px 14px',background:'#202a32',border:'1px solid #53606a',
      borderRadius:16,color:'#f1f5f9',boxShadow:'0 4px 18px #0003'}}>
      <div style={{fontWeight:700,fontSize:13}}> {call.kind === 'video' ? '📹' : '📞'} {call.kind === 'video' ? 'Video' : 'Voice'} call · {call.result}</div>
      <div style={{fontSize:12,color:'#c6d2dc',marginTop:5}}>
        {call.mediaConnected ? `Talk time ${duration(call.talkDurationSeconds)}` :
          call.answered ? (!call.endedAt ? 'Connecting media…' : String(call.result).includes('unverified') ? 'Connection not verified for this older call' : 'Answered, but media did not connect') : `Rang ${duration(call.ringDurationSeconds)}`}
      </div>
      <div style={{fontSize:11,color:'#9eb2c0',marginTop:5}}>{when ? new Date(when).toLocaleString('en-IN',{dateStyle:'medium',timeStyle:'short'}) : ''}</div>
    </div>
  </div>;
}
